import { Link } from 'react-router-dom'

function Footer() {
    const year = new Date().getFullYear();

    const links = [
        { to: '/terms', label: 'Terms & Conditions' },
        { to: '/privacy-policy', label: 'Privacy Policy' },
        { to: '/contact', label: 'Contact' },
    ];

    return (
        <footer className="mt-10 border-t border-gray-100 dark:border-white/[.06] pt-6 pb-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
                    {links.map(({ to, label }) => (
                        <Link
                            key={to}
                            to={to}
                            className="text-xs text-gray-400 dark:text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
                        >
                            {label}
                        </Link>
                    ))}
                </nav>

                <p className="text-xs text-gray-400 dark:text-gray-500">
                    &copy; 2019–{year} CedisPay Micro-Finance Limited
                </p>
            </div>
        </footer>
    );
}

export default Footer;
